"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asFormElement = exports.FormConsumer = exports.FormWithoutRef = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["elementInError"],
    _excluded2 = ["fn"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FormContext = /*#__PURE__*/_react["default"].createContext({});

var Form = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Form, _Component);

  var _super = _createSuper(Form);

  function Form(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Form);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "populate", function (_ref) {
      var _ref$values = _ref.values,
          values = _ref$values === void 0 ? {} : _ref$values,
          _ref$validations = _ref.validations,
          validations = _ref$validations === void 0 ? {} : _ref$validations;

      var updated = _objectSpread({}, _this.state);

      updated.values = _objectSpread(_objectSpread({}, _this.state.values), values);
      updated.validations = _objectSpread(_objectSpread({}, _this.state.validations), validations);

      _this.setState(updated);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clear", function (_ref2) {
      var name = _ref2.name,
          _ref2$initialValue = _ref2.initialValue,
          initialValue = _ref2$initialValue === void 0 ? '' : _ref2$initialValue;
      var values = _this.state.values;
      values[name] = initialValue;

      _this.setState({
        values: values
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (_ref3) {
      var name = _ref3.name,
          value = _ref3.value;
      var _this$state = _this.state,
          values = _this$state.values,
          validations = _this$state.validations;
      values[name] = value; // enalbe max-selection of checkboxes

      if (_this.props.maxCheckboxSelect) {
        var _Object$values$filter;

        var selected = (_Object$values$filter = Object.values(values).filter(function (val) {
          return val;
        })) === null || _Object$values$filter === void 0 ? void 0 : _Object$values$filter.length; // selects the truthy checkboxes

        if (selected > _this.props.maxCheckboxSelect) {
          // Initially we set values[name] = value; for checkboxes thats: [name]: true/false
          // revert the truthy value when we exceed the max selection
          values[name] = !value;
          return;
        }
      }

      if (validations[name]) {
        var validated = _this.validate(name, value, validations);

        validations[name] = validated;
      }

      if (_this.props.onChange) {
        _this.props.onChange({
          values: values,
          validations: validations
        });
      }

      _this.setState({
        values: values,
        validations: validations
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "validate", function (name, value, validations) {
      var flag = false;
      var _validations$name = validations[name],
          elementInError = _validations$name.elementInError,
          toValidate = (0, _objectWithoutProperties2["default"])(_validations$name, _excluded);

      var validated = _objectSpread({}, toValidate);

      Object.keys(toValidate).forEach(function (key) {
        var _toValidate$key = toValidate[key],
            fn = _toValidate$key.fn,
            rest = (0, _objectWithoutProperties2["default"])(_toValidate$key, _excluded2);
        var isValid = fn(value, rest);
        validated[key].error = isValid;
        flag = flag || isValid;
      });
      validations[name] = validated;
      validations[name].elementInError = flag;
      return validations[name];
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "register", function (name, initialValue, validate) {
      var _this$state2 = _this.state,
          values = _this$state2.values,
          validations = _this$state2.validations;
      values[name] = initialValue;

      if (validate && Object.keys(validate).length !== 0) {
        validations[name] = validate;
        validations[name].elementInError = false;
      }

      _this.setState({
        values: values,
        validations: validations
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "unregisterFormElement", function (name) {
      var _this$state3 = _this.state,
          values = _this$state3.values,
          validations = _this$state3.validations;
      delete values[name];
      delete validations[name];

      _this.setState({
        values: values,
        validations: validations
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleSubmit", function (event) {
      event.preventDefault();
      var flag = false;
      var errorNames = [];
      var _this$state4 = _this.state,
          values = _this$state4.values,
          validations = _this$state4.validations;
      Object.keys(validations).forEach(function (name) {
        validations[name] = _this.validate(name, values[name], validations);
        if (validations[name].elementInError) errorNames.push(name);
        flag = flag || validations[name].elementInError;
      });

      if (_this.props.scrollToError && errorNames.length > 0) {
        var label = document.querySelector("label[name=\"".concat(errorNames[0], "\""));
        var properties = {
          behavior: 'smooth',
          block: 'center'
        };
        label.scrollIntoView(properties);
      }

      _this.setState({
        validations: validations,
        formInError: flag,
        submitAttempted: true
      }, function () {
        if (_this.props.onSubmit) {
          _this.props.onSubmit({
            values: _this.state.values,
            formInError: _this.state.formInError
          });
        }
      });
    });
    _this.state = {
      values: {},
      validations: {},
      submitAttempted: false,
      formInError: false
    };
    return _this;
  } // If the 'submit' event needs to be triggered from outside the form
  // Event is cancelable to make sure that preventDefault works correctly across all browsers


  (0, _createClass2["default"])(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.formRef && this.props.formRef.current) {
        this.props.formRef.current.triggerSubmission = function () {
          return _this2.props.formRef.current.dispatchEvent(new Event('submit', {
            cancelable: true
          }));
        }; // FIXME: Really shouldn't be attaching functions to passing refs
        // but formRef was meant for Form synthetic component, not form HTML Element


        this.props.formRef.current.populate = this.populate;
        this.props.formRef.current.unregisterFormElement = this.unregisterFormElement;
      }
    } // A ref for updating values/validations dynamically after the form has been constructed.

  }, {
    key: "render",
    value: function render() {
      var _this$state5 = this.state,
          values = _this$state5.values,
          validations = _this$state5.validations,
          submitAttempted = _this$state5.submitAttempted;
      return /*#__PURE__*/_react["default"].createElement(FormContext.Provider, {
        value: {
          values: values,
          validations: validations,
          submitAttempted: submitAttempted,
          register: this.register,
          unregister: this.unregisterFormElement,
          onChange: this.onChange,
          clear: this.clear
        }
      }, /*#__PURE__*/_react["default"].createElement("form", {
        ref: this.props.formRef,
        noValidate: true,
        onSubmit: this.handleSubmit,
        className: this.props.className
      }, this.props.children));
    }
  }]);
  return Form;
}(_react.Component);

exports.FormWithoutRef = Form;
(0, _defineProperty2["default"])(Form, "propTypes", {
  onSubmit: _propTypes["default"].func,
  children: _propTypes["default"].node.isRequired,
  onChange: _propTypes["default"].func,
  className: _propTypes["default"].string,
  scrollToError: _propTypes["default"].bool,
  formRef: _propTypes["default"].shape(),
  maxCheckboxSelect: _propTypes["default"].number
});
(0, _defineProperty2["default"])(Form, "defaultProps", {
  onSubmit: undefined,
  onChange: undefined,
  className: '',
  scrollToError: false,
  formRef: undefined,
  maxCheckboxSelect: null
});
var FormConsumer = FormContext.Consumer;
exports.FormConsumer = FormConsumer;

var asFormElement = function asFormElement(Element) {
  var withProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var PassedValidations = arguments.length > 2 ? arguments[2] : undefined;
  // if component is memoized it will have Element.type.Validations
  var isElementMemoized = !!Element.type;

  var FormElement = /*#__PURE__*/function (_React$PureComponent) {
    (0, _inherits2["default"])(FormElement, _React$PureComponent);

    var _super2 = _createSuper(FormElement);

    function FormElement(props, context) {
      var _this3;

      (0, _classCallCheck2["default"])(this, FormElement);
      _this3 = _super2.call(this, props);
      if (_this3.props.noRegister || !context || !context.register) return (0, _possibleConstructorReturn2["default"])(_this3);

      var spreadProps = _objectSpread(_objectSpread({}, _this3.props), withProps); // eslint-disable-next-line max-len


      var value = spreadProps.initialValue !== undefined ? spreadProps.initialValue : spreadProps.value;
      var validations = {};
      var validate = spreadProps.validate,
          name = spreadProps.name;
      var Validations;

      if (isElementMemoized) {
        Validations = _objectSpread(_objectSpread({}, Element.type.Validations), PassedValidations);
      } else {
        Validations = _objectSpread(_objectSpread({}, Element.Validations), PassedValidations);
      }

      if (validate) {
        Object.keys(validate).forEach(function (key) {
          if ((0, _typeof2["default"])(validate[key]) === 'object') Validations[key] = _objectSpread(_objectSpread({}, Validations[key]), validate[key]);

          if (typeof validate[key] === 'number') {
            validations[key] = _objectSpread({}, Validations[key](validate[key]));
          } else {
            validations[key] = _objectSpread({}, Validations[key]);
          }

          validations[key].error = false;
        });
      }

      context.register(name, value, validations);
      return _this3;
    }

    (0, _createClass2["default"])(FormElement, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this$context, _this$context$unregis;

        // eslint-disable-next-line no-unused-expressions
        (_this$context = this.context) === null || _this$context === void 0 ? void 0 : (_this$context$unregis = _this$context.unregister) === null || _this$context$unregis === void 0 ? void 0 : _this$context$unregis.call(_this$context, this.props.name);
      }
    }, {
      key: "render",
      value: function render() {
        var _spreadProps$validate;

        var spreadProps = _objectSpread(_objectSpread({}, this.props), withProps); // eslint-disable-next-line max-len


        if (spreadProps.noRegister || !this.context || !this.context.register) return /*#__PURE__*/_react["default"].createElement(Element, spreadProps);
        var _this$context2 = this.context,
            register = _this$context2.register,
            _this$context2$valida = _this$context2.validations,
            validations = _this$context2$valida === void 0 ? {} : _this$context2$valida,
            values = _this$context2.values,
            onChange = _this$context2.onChange,
            submitAttempted = _this$context2.submitAttempted,
            clear = _this$context2.clear;
        var elementValidate = {};

        if (validations[spreadProps.name]) {
          elementValidate = validations[spreadProps.name];
        }

        var isRequired = !!(spreadProps !== null && spreadProps !== void 0 && (_spreadProps$validate = spreadProps.validate) !== null && _spreadProps$validate !== void 0 && _spreadProps$validate.required);
        return /*#__PURE__*/_react["default"].createElement(Element, (0, _extends2["default"])({}, _objectSpread(_objectSpread({}, spreadProps), withProps), {
          onChange: onChange,
          register: register,
          value: values[spreadProps.name],
          validations: elementValidate,
          submitAttempted: submitAttempted,
          isRequired: isRequired,
          clear: clear,
          ref: this.props.forwardedRef
        }));
      }
    }]);
    return FormElement;
  }(_react["default"].PureComponent);

  FormElement.contextType = FormContext;
  var propTypes = isElementMemoized ? Element.type.PropTypes : Element.PropTypes;
  FormElement.propTypes = _objectSpread({
    name: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].any
  }, propTypes);
  var defaultProps = isElementMemoized ? Element.type.defaultProps : Element.defaultProps;
  FormElement.defaultProps = _objectSpread(_objectSpread({
    initialValue: ''
  }, defaultProps), {}, {
    submitAttempted: false,
    onChange: function onChange() {}
  });
  return /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(FormElement, (0, _extends2["default"])({}, props, {
      forwardedRef: ref
    }));
  });
};

exports.asFormElement = asFormElement;

var FormWithRef = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(Form, (0, _extends2["default"])({
    formRef: ref
  }, props));
});

FormWithRef.displayName = 'Form';
var _default = FormWithRef;
exports["default"] = _default;